// extracted by mini-css-extract-plugin
export default {"layout":"Header_layout__YQQF2","main-title":"Header_main-title__K0vln","main-title-text":"Header_main-title-text__y6QCb","subtitle-text":"Header_subtitle-text__pP+Rq"};